import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LeilaoPesquisaComponent } from './pesquisa/leilao-pesquisa.component';
import { LeilaoRoutingModule } from './leilao-routing.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { LeilaoListagemComponent } from './pesquisa/leilao-listagem/leilao-listagem.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { LeilaoLoteComponent } from './leilao-lote/leilao-lote.component';
import { ConsultaStatusLeilaoComponent } from './consulta-status-leilao/consulta-status-leilao.component';
import { ConsultaStatusLeilaoListagemComponent } from './consulta-status-leilao/consulta-status-leilao-listagem/consulta-status-leilao-listagem.component';
import { DetalheLeilaoComponent } from './detalhe-leilao/detalhe-leilao.component';

@NgModule({
  declarations: [
    LeilaoPesquisaComponent,
    LeilaoListagemComponent,
    LeilaoLoteComponent,
    ConsultaStatusLeilaoComponent,
    ConsultaStatusLeilaoListagemComponent,
    DetalheLeilaoComponent
  ],
  imports: [
    CommonModule,
    LeilaoRoutingModule,
    SharedModule,
    NgSelectModule
  ]
})
export class LeilaoModule { }
